import type { FC } from "react";

import classNames from "classnames";

import type {
  BirthDateFormDropdownsFormat,
  BirthDateFormInputsFormat,
} from "@jti/ui/eva-components/SoftAgeVerification";
import { BirthDateFormInputs as BirthDateFormInputsUI } from "@jti/ui/eva-components/SoftAgeVerification";

import type { birthDateFormInputs } from "./BirthDateFormInputs.builder";

import styles from "./BirthDateFormInputs.module.scss";

type BirthDateFormInputsProps = BuilderComponentProps<typeof birthDateFormInputs>;

export const BirthDateFormInputs: FC<BirthDateFormInputsProps> = ({
  format,
  inputType,
  attributes,
  ...commonProps
}) => {
  if (inputType === "dropdowns") {
    return (
      <div {...attributes} className={classNames(styles.wrapper, attributes?.className)}>
        <BirthDateFormInputsUI {...commonProps} inputType={inputType} format={format as BirthDateFormDropdownsFormat} />
      </div>
    );
  }
  return (
    <div {...attributes} className={styles.wrapper}>
      <BirthDateFormInputsUI {...commonProps} inputType={inputType} format={format as BirthDateFormInputsFormat} />
    </div>
  );
};
